import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/Tables/CustomTable";
import { MoreVertical } from "lucide-react";
import Button from "../../ui/Button";
import DropdownMenu from "../../ui/DropdownMenu";
import AddAdminModal from "./AddAdmin";
import EditAdminModal from "./EditAdmin";
import DisableAdminModal from "./AdminDeleteSuccess";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import SearchInput from "../../../components/form/SearchInput";
import WhiteTitledCard from "./../../../components/cards/WhiteTitledCard";
import {
  fetchUsersAsync,
  resetAdminState,
} from "../../../redux/features/adminSlice";
import { cleanObject } from "../../../helpers";
import moment from "moment";

const AdminTable: React.FC = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState<any>();
  const [disabledAgent, setDisabledAgent] = useState(false);
  const { users, isLoading } = useAppSelector((state) => state.admin);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [inputValue, setInputValue] = useState("");
  const dispatch = useAppDispatch();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Admin", field: "admin_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Country", field: "country" },
    { label: "Reg. Date", field: "date_added" },
    { label: "Action", field: "action" },
  ];

  const dropdownOptions = [
    {
      label: "Edit admin",
      onClick: (admin: any) => {
        setOpenEdit(true);
        setSelectedAdmin(admin);
      },
      returnAll: true,
    },
    {
      label: <span className="text-red-500">Disable admin</span>,
      onClick: (admin: any) => {
        setDisabledAgent(true);
        setSelectedAdmin(admin);
      },
      returnAll: true,
    },
  ];

  const adminData = users?.data?.data?.map((admin: any, index: number) => {
    return {
      id: index + 1,
      admin_name: admin?.fullName ?? "N/A",
      username: admin?.username ?? "N/A",
      phone_number: admin?.phoneNumber ?? "N/A",
      country: admin?.country?.name ?? "N/A",
      email: admin?.email ?? "N/A",
      action: (
        <DropdownMenu
          options={dropdownOptions}
          icon={<MoreVertical style={{ cursor: "pointer" }} />}
          item={admin}
        />
      ),
      date_added: moment(admin?.createdAt).format("MMM DD, YYYY"),
    };
  });

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilter(inputValue);
    }
  };

  useEffect(() => {
    dispatch(resetAdminState());
    const parameters = cleanObject({
      page: page + 1,
      limit,
      filter,
      userType: "ADMIN",
    });
    dispatch(fetchUsersAsync(parameters));
  }, [page, limit, filter, dispatch]);

  const tabList = [
    { id: 1, name: "All Admins", count: users?.data?.totalItems ?? 0 },
  ];

  return (
    <WhiteTitledCard>
      <div className="px-6 sm:p-6">
        <div className="sm:flex-row flex-col-reverse flex items-start sm:items-center justify-between mb-4">
          {tabList?.map((tab) => (
            <div
              key={tab.id}
              className={`space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary
                 `}
            >
              <span>{tab.name}</span>
              {tab?.count && (
                <span className={"bg-lightPurple px-2  text-accent rounded-md"}>
                  {tab?.count}
                </span>
              )}
            </div>
          ))}
          <div className=" flex-col-reverse sm:flex-row sm:items-center gap-4 flex">
            <SearchInput
              placeholder="Search"
              onChange={(e: any) => {
                setInputValue(e.target.value);
                setPage(0);
              }}
              value={inputValue}
              onKeyDown={handleKeyDown}
            />
            <Button
              customStyle={{
                width: "auto",
                height: "40px",
              }}
              label="filter"
              onClick={() => setFilter(inputValue)}
              classNames="hidden sm:flex"
            />
            <Button
              customStyle={{ width: "auto", minWidth: "150px", height: "40px" }}
              label="Add admin"
              onClick={() => setOpenAdd(true)}
            />
          </div>
        </div>
        <CustomTable
          data={{ columns, rows: adminData }}
          loading={isLoading}
          showFooter={true}
          noRecordText="No Admin Users Available"
          totalPages={users?.data?.totalPages}
          itemsPerPage={users?.data?.itemsPerPage}
          currentPage={page}
          onPageChange={(value: number) => setPage(value)}
          onLimitChange={(value: number) => {
            setLimit(value);
            setPage(0);
          }}
        />
        <AddAdminModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSave={() => {
            dispatch(
              fetchUsersAsync({
                page: page + 1,
                limit,
                filter,
                userType: "ADMIN",
              })
            );
          }}
        />
        <EditAdminModal
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          selectedAdmin={selectedAdmin}
        />
        <DisableAdminModal
          isOpen={disabledAgent}
          onClose={() => setDisabledAgent(false)}
          adminId={selectedAdmin?.id}
          onConfirm={() => {
            dispatch(
              fetchUsersAsync({
                page: page + 1,
                limit,
                filter,
                userType: "ADMIN",
              })
            );
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default AdminTable;
